import { useCallback } from "../../../__compat__/react/main.entry.mjs.mjs";
import { isSameDay, isToday, isFirstDayOfMonth, startOfToday, } from "../../../__compat__/date-fns/main.entry.mjs.mjs";
import { isRange, isStart, isEnd, isEmptySelection, isSameMonthAndYear, } from "../dateHelpers.mjs.mjs";
/* first of month only selectable if selection or today is not in same month */
export function isFirstOfMonthSelectable(selection = null, date) {
    return Boolean(isFirstDayOfMonth(date) &&
        !isSameMonthAndYear(selection, date) &&
        !isSameMonthAndYear(startOfToday(), date));
}
/* notes */
export function isTodaySelectable(selection = null, date) {
    return Boolean(isToday(date) &&
        (isEmptySelection(selection) || !isSameMonthAndYear(selection, date)));
}
export function useCalendarTabIndex(selection = null) {
    const getTabIndex = useCallback((date) => {
        if (isRange(selection)) {
            if (isStart(selection, date) || isEnd(selection, date))
                return 0;
        }
        else {
            if (selection !== null && isSameDay(selection, date))
                return 0;
        }
        if (isTodaySelectable(selection, date))
            return 0;
        if (isFirstOfMonthSelectable(selection, date))
            return 0;
        return -1;
    }, [selection]);
    return {
        getTabIndexProp: (date) => ({ tabIndex: getTabIndex(date) }),
    };
}
//# sourceMappingURL=useCalendarTabIndex.mjs.mjs.map